import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function idr(n) {
  if (n == null) return "-";
  return "Rp" + Number(n).toLocaleString("id-ID");
}

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
  } catch { return iso; }
}

export function normalizeImageUrl(url) {
  if (!url || typeof url !== "string") return url;
  const trimmed = url.trim();
  if (!/google/.test(trimmed)) return trimmed;
  const m = trimmed.match(/\/d\/([a-zA-Z0-9_-]{20,})/) || trimmed.match(/[?&]id=([a-zA-Z0-9_-]{20,})/);
  if (m) return `https://lh3.googleusercontent.com/d/${m[1]}`;
  return trimmed;
}
